export const HEADER_MENU = [
    {
        key: "header-introduction",
        path: "/",
        outside: false,
        active: true,
    },
    {
        key: "header-solution",
        path: "/solutions",
        outside: false,
        active: true,
    },
    {
        key: "header-service",
        path: "/services",
        outside: false,
        active: true,
    },
    // {
    //     key: "header-wearable",
    //     path: "/wearable",
    //     outside: false,
    //     active: true,
    // },
    {
        key: "header-r&bd",
        path: "/R&BD",
        outside: false,
        active: false,
    },
    {
        key: "header-mall",
        path: "https://smartstore.naver.com/thepureungigu",
        outside: true,
        active: true,
    },
    {
        key: "header-help-center",
        path: "/help-center",
        outside: false,
        active: true,
    },
]